module.exports = __webpack_public_path__ + "static/img/logo3.a470031.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo3.png
// module id = eL/l
// module chunks = 1